import { Component, Input } from '@angular/core';

import { DateTimezonePipe } from '../../pipes/date-timezone.pipe';
import { AlcmeonCardFooter } from './models/alcmeon-card-footer.model';

/**
 * Common component used to show the create and modify information
 * The dates must be in iso string format.
 * If a value is missing among the AlcmeonCardFooter's props then the related column will be hidden
 * @example  <app-card-footer *ngIf="footerContent" [data]="footerContent"></app-card-footer>
 * this.footerContent = {
 *   createdBy: name,
 *   createdAt: '2000-01-01T00:00:00.000Z',
 *   modifiedBy: name,
 *   modifiedAt: '2000-01-01T00:00:00.000Z',
 * }
 */
@Component({
  selector: 'app-card-footer',
  templateUrl: './card-footer.component.html',
  styleUrls: ['./card-footer.component.scss'],
})
export class CardFooterComponent {
  private _data: AlcmeonCardFooter;

  @Input()
  get data(): AlcmeonCardFooter {
    return this._data;
  }
  set data(data: AlcmeonCardFooter) {
    this._data = data;
    this.reevaluateData();
  }

  constructor(private dateTimezonePipe: DateTimezonePipe) {}

  reevaluateData(): void {
    if (this.data) {
      const { modifiedAt, createdAt } = this.data;
      if (modifiedAt) {
        this.data['modifiedAtLabel'] = this.dateTimezonePipe.transform(modifiedAt, 'short');
      }
      if (createdAt) {
        this.data['createdAtLabel'] = this.dateTimezonePipe.transform(createdAt, 'short');
      }
    }
  }
}
